import { Outlet, createFileRoute } from '@tanstack/react-router'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

// Layout route para /dashboard/$dashboardId/sistema/agentes
// Este arquivo (route.tsx) serve como layout que envolve todas as rotas filhas
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/agentes',
)({
  component: function AgentesLayoutRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.IA_AGENTES} dashboardId={dashboardId}>
        <Outlet />
      </RequireModule>
    )
  },
})
